/**
 * Client-side mirror of the palette in worker/lib/annotations.js.
 * These are the 5 colors the UI exposes. Server accepts any valid hex.
 */
export const ANNOTATION_PALETTE = [
  { name: "Orange", hex: "#e8500a" },
  { name: "Blue",   hex: "#2196f3" },
  { name: "White",  hex: "#ffffff" },
  { name: "Yellow", hex: "#f4c430" },
  { name: "Green",  hex: "#22c55e" },
] as const;
